export const SEARCH_WIZARD_TYPE_NAME = {
  SEARCH_CAMPAIGN_EDIT_WIZARD: 'SearchCampaignEditWizard',
};
